module.exports = __webpack_public_path__ + "static/media/map.58e2a348.svg";